//import useState hook to create menu collapse state
import React from "react";

//import react pro sidebar components
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import minimalLogo from "../../assets/leduca_logo_minimal.png";
import dash from "../../assets/dash.png";
import dashDisable from "../../assets/dash-disable.png";
import chat from "../../assets/chat.png";
import chatDisable from "../../assets/chat-disable.png";
import subjects from "../../assets/subject.png";
import subjectsDisable from "../../assets/subject-disable.png";
import { Avatar } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ExitToApp from "../../assets/exittoapp.png";
import Popup from "reactjs-popup";
import app from "../../services/base.js";
import emptyCache from "../../utils/cleanCache";
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import "react-pro-sidebar/dist/css/styles.css";
import "./Navbar.scss";

async function logout() {
  app
    .auth()
    .signOut()
    .then(() => {
      window.location.href = "/";
      emptyCache();
    });
}

const useStyles = makeStyles({
  tooltip: {
    fontSize: "1.5em",
    maxWidth: 200,
  },
});
const blockText = "Você ainda não possui permissão como admistrador de uma comunidade."
const Navbar = ({ profileImage, changeNavbarState, navbarActive, dashboardActive }) => {
  const classes = useStyles();

  return (
    <>
      <div id="navbar" className="side-menu">
        <ProSidebar>
          <SidebarHeader>
            <div className="header-logo">
              <img src={minimalLogo} height={30} />
            </div>
          </SidebarHeader>

          <SidebarContent>
            <Menu>
              {/* Perfil */}
              <MenuItem>
                <Avatar src={profileImage} style={{ marginLeft: 5 }} />
              </MenuItem>

              {/* Conversas */}
              <MenuItem
                active={navbarActive === "conversation"}
                onClick={() => changeNavbarState("conversation")}
                icon={
                  <IconButton color="primary" component="span">
                    <img src={ navbarActive === "conversation"? chat : chatDisable } height={28} width={28} />
                  </IconButton>
                }
              />

              {/* Dashboard */}
              <Tooltip
                classes={{tooltip: classes.tooltip}}  
                title={ dashboardActive ? null : blockText  }
                leaveDelay={400}
                disableHoverListener={dashboardActive}
                placement='right'
              >
                <MenuItem
                  active={navbarActive === "dashboard"}
                  onClick={() => {
                    if(dashboardActive){
                      changeNavbarState("dashboard")
                    }                  
                  }}
                  icon={
                    
                      <IconButton color="primary" component="span">
                        <img src={ navbarActive === "dashboard"? dash : dashDisable } height={28} width={28} />
                      </IconButton>
              
                  }
                />
              </Tooltip>
              {/* Disciplinas */}
              <MenuItem
                active={navbarActive === "subjects"}
                onClick={() => {changeNavbarState("subjects")}}
                icon={
                  
                    <IconButton color="primary" component="span">
                      <img src={ navbarActive === "subjects"? subjects : subjectsDisable } height={28} width={28} />
                    </IconButton>
            
                }
              />

              <MenuItem>
                <Popup
                  className={"popup-content"}
                  contentStyle={{
                    width: 400,
                  }}
                  trigger={
                    <div className="exit-button" style={{ marginLeft: 15 }}>
                      <img
                        src={ExitToApp}
                        alt="exit-button"
                        height={22}
                        width={22}
                      />
                    </div>
                  }
                  modal
                  nested
                >
                  {(close) => (
                    <div className="popup-modal">
                      <div className="popup-header">
                        Tem certeza de que deseja sair?
                      </div>
                      <div className="popup-content">
                        Ao confirmar, sua conta será desconectada.
                      </div>
                      <div className="popup-actions">
                        <button
                          className="popup-cancel-button"
                          onClick={() => {
                            close();
                          }}
                        >
                          <span>Cancelar</span>
                        </button>
                        <button
                          className="popup-confirm-button"
                          onClick={() => {
                            logout();
                            close();
                          }}
                        >
                          <span>Sair</span>
                        </button>
                      </div>
                    </div>
                  )}
                </Popup>
              </MenuItem>
            </Menu>
          </SidebarContent>

          <SidebarFooter>V. 1.0.0</SidebarFooter>
        </ProSidebar>
      </div>
    </>
  );
};

export default Navbar;
